import { RESPONSE_STATUS_CODES } from '@whitelist/wl-old-library/constants/serverConstants'
import { parseNotificationString } from '@/constants/notifications'
import services from '@/services'
import { Notification } from './types'
import moment from 'moment'

export interface NotificationsFilters {
  order: 'created_at' | '-created_at',
  page: number,
  read?: boolean
}

export const createNotificationsPaginationGenerator = async function * (filters: NotificationsFilters) {
  const filtersMutable = Object.assign({}, filters)

  while (filtersMutable.page > 0) {
    const filtersStringEntries = Object.entries(filtersMutable).map(([key, value]) => [key, String(value)])
    const searchParams = new URLSearchParams(filtersStringEntries)
    const response = await services.notifications.loadNotifications({ payload: null, query: `?${searchParams.toString()}` })
    if (response.status === RESPONSE_STATUS_CODES.OK) {
      filtersMutable.page = response.data.has_next ? response.data.next_page_number : 0
    }
    yield response
  }
}

export const prioritizeModals = (a: Notification, b: Notification) => {
  if (a.blockUi && !b.blockUi) return 1
  if (b.blockUi && !a.blockUi) return -1

  const aCreatedMoment = moment(a.createdAt.slice(0, -4))
  const bCreatedMoment = moment(b.createdAt.slice(0, -4))

  if (bCreatedMoment.isBefore(aCreatedMoment)) {
    return 1
  }

  if (aCreatedMoment.isBefore(bCreatedMoment)) {
    return -1
  }

  return 0
}

export const getAlertAction = ({ actions, vars }: Notification) => {
  if (actions.mainButton === undefined) return undefined

  const mainButton = {
    text: parseNotificationString(actions.mainButton.text, vars),
    url: parseNotificationString(actions.mainButton.url, vars)
  }

  return {
    text: mainButton.text,
    position: 'bottom',
    callback: () => {
      window.open(mainButton.url, '_blank')
    }
  }
}

export const getModalAction = ({ actions, vars }: Notification, onClose: () => unknown) => {
  const result: any = []
  if (actions.mainButton !== undefined) {
    const mainButton = {
      text: parseNotificationString(actions.mainButton.text, vars),
      url: parseNotificationString(actions.mainButton.url, vars)
    }
    result.push({
      title: mainButton.text,
      isAccent: true,
      callback: async () => {
        await onClose()
        if (mainButton.url.length > 0) {
          window.open(mainButton.url, '_self')
        }
      }
    })
  }

  return result.length === 0 ? undefined : result
}
